import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const eur = (n) => `${n.toFixed(2).replace(".", ",")} €`;

const monthLabel = (m) => {
  const [y, mo] = m.split("-").map(Number);
  const s = new Date(y, mo - 1, 1).toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const localMonth = (iso) => {
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const downloadCommissionPdf = ({ row, rate, deposits, conciergeName, isCurrent }) => {
  const doc = new jsPDF();
  const pct = Math.round(rate * 100);
  const list = deposits.filter((d) => d.person_type === "client" && localMonth(d.created_at) === row.month)
    .sort((a, b) => a.created_at.localeCompare(b.created_at));

  doc.setFontSize(18);
  doc.text(`${conciergeName} — Relevé de commission`, 14, 20);
  doc.setFontSize(12);
  doc.text(`${monthLabel(row.month)}${isCurrent ? " (mois en cours, estimation)" : ""}`, 14, 28);
  doc.setFontSize(10);
  doc.text(`Édité le ${new Date().toLocaleString("fr-FR")} — Partenariat Pressing Sakura`, 14, 34);

  autoTable(doc, {
    startY: 40,
    theme: "grid",
    head: [["Total facturé clients pro", `Part conciergerie (${pct} %)`, "Nombre de bons", "Statut"]],
    body: [[eur(row.base_total), eur(row.commission), String(row.deposits_count),
      isCurrent ? "En cours" : row.paid ? `Payé le ${new Date(row.paid_at).toLocaleDateString("fr-FR")}` : "À verser"]],
    headStyles: { fillColor: [219, 39, 119] },
  });

  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 10,
    head: [["Date", "N° de bon", "Client", "Entreprise", "Marquage", "Articles", "Total"]],
    body: list.map((d) => [
      new Date(d.created_at).toLocaleDateString("fr-FR"), d.number, d.person_name, d.company_name || "",
      d.tracking_number || "", d.items.map((i) => `${i.quantity}× ${i.name}`).join(", "), eur(d.total),
    ]),
    foot: [["", "", "", "", "", "Total", eur(list.reduce((s, d) => s + d.total, 0))]],
    styles: { fontSize: 8 },
    headStyles: { fillColor: [15, 23, 42] },
    footStyles: { fillColor: [241, 245, 249], textColor: 20, fontStyle: "bold" },
    columnStyles: { 5: { cellWidth: 55 }, 6: { halign: "right" } },
  });

  doc.save(`commission-${row.month}.pdf`);
};
